var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("运输单")]), _vm._l(_vm.displayData, function (d) {
    return _c('div', {
      staticClass: "section-block"
    }, [_c('h3', {
      staticClass: "block-title"
    }, [_vm._v(_vm._s(d.title))]), _c('span', {
      staticClass: "block-displaytext"
    }, [_vm._v(_vm._s(d.displayText || "-"))])]);
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }